import { baseFetch, RequestOptions } from '../../baseFetch';
import { EmptyResponseSchema } from '../../schemas/EmptyResponseSchema';
import {
  OrgPermissionSchema,
  OrgPermissionsResponseSchema,
} from './org-permissions.schema';

export type PermissionUserType = 'org' | 'user';

export type PermissionRole = 'admin' | 'viewer';

export const getOrgPermissions = (
  orgId: number,
  filters?: {
    userType?: PermissionUserType;
    roles?: Array<PermissionRole>;
    userIds?: Array<string>;
  },
  paginationToken?: string,
  { limit, signal }: { limit?: number; signal?: AbortSignal } = {},
) => {
  const searchParams: RequestOptions<unknown>['searchParams'] = {};

  if (filters?.userType) {
    searchParams.user_type = filters.userType;
  }
  if (filters?.roles) {
    searchParams.role_ids = filters.roles;
  }
  if (filters?.userIds) {
    searchParams.user_ids = filters?.userIds;
  }

  if (paginationToken) {
    searchParams.pagination_token = paginationToken;
  }

  if (limit) {
    searchParams.limit = limit.toString();
  }

  return baseFetch(
    'auth',
    `/org-permissions/orgs/${orgId}/permissions`,
    OrgPermissionsResponseSchema.defined(),
    {
      searchParams,
      headers: {
        'Cache-Control': 'max-age=0',
      },
      abortSignal: signal,
    },
  );
};

export const updateOrgPermission = (
  orgId: number,
  permissionId: number,
  newRole: PermissionRole,
) => {
  return baseFetch(
    'auth',
    `/org-permissions/orgs/${orgId}/permissions/${permissionId}/role`,
    OrgPermissionSchema.defined(),
    {
      method: 'PATCH',
      requestBody: {
        role_id: newRole,
      },
    },
  );
};

export const addOrgPermission = (
  orgId: number,
  auth0UserId: string,
  newRole: PermissionRole,
) => {
  return baseFetch(
    'auth',
    `/org-permissions/orgs/${orgId}/permissions`,
    OrgPermissionSchema.defined(),
    {
      method: 'POST',
      requestBody: {
        user_type: 'user',
        role_id: newRole,
        user_id: auth0UserId,
      },
    },
  );
};

export const removeOrgPermission = (orgId: number, permissionId: number) => {
  return baseFetch(
    'auth',
    `/org-permissions/orgs/${orgId}/permissions/${permissionId}`,
    EmptyResponseSchema,
    {
      method: 'DELETE',
    },
  );
};
